module.exports = "/_next/static/images/cars-charging-32d8a95a9840d1a2819582b68e67e79d.jpg.webp";